import { Product, ProductDash, ProductsApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class ProductApiService {
	constructor(private productApi: ProductsApi = new ProductsApi()) {}

	public async getProductById(
		id: number,
		options?: any,
	): Promise<{ product?: Product; errorMessage?: string }> {
		try {
			const response = await this.productApi.getProductById(id, options);
			return { product: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch Product by id: ${id}`);
		}
	}

	public async getDashByProductId(
		id: number,
		options?: any,
	): Promise<{ dash?: ProductDash; errorMessage?: string }> {
		try {
			const response = await this.productApi.getProductDash(id, options);
			return { dash: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch Product Dash by id: ${id}`);
		}
	}
}
